(() => {
  const init = () => {
    const root = document.querySelector('.sf-license-configurator');
    if (!root || root.dataset.sfConversionReady) return;
    root.dataset.sfConversionReady = 'true';
    const form = root.querySelector('#sf-license-form');
    const quantity = root.querySelector('#sfk-quantity');
    const nativeSubmit = root.querySelector('.sfk-submit');
    const row = root.querySelector('.sfk-buy-row');
    const bar = root.querySelector('[data-sf-mobile-buy]');
    const stickySubmit = root.querySelector('[data-sf-mobile-submit]');
    const total = root.querySelector('[data-sf-mobile-total]');
    const choices = root.querySelectorAll('[data-sf-plate-quantity]');
    if (!form || !quantity || !nativeSubmit || !row || !bar || !stickySubmit || !total) return;
    let rowVisible = true;
    const mobile = window.matchMedia('(max-width:749px)');
    const measureBar = () => {
      if (bar.hidden || !mobile.matches) return;
      document.body.style.setProperty('--sf-mobile-buy-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    };
    const update = () => {
      choices.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.sfPlateQuantity) === quantity.valueAsNumber)));
      total.textContent = root.querySelector('[data-total]')?.textContent || '—';
      stickySubmit.textContent = nativeSubmit.disabled ? stickySubmit.dataset.incomplete : stickySubmit.dataset.ready;
      bar.hidden = !mobile.matches || rowVisible;
      document.body.classList.toggle('sf-mobile-buy-active', !bar.hidden);
      measureBar();
    };
    choices.forEach(button => button.addEventListener('click', () => {
      quantity.value = button.dataset.sfPlateQuantity;
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    stickySubmit.addEventListener('click', () => {
      root.dispatchEvent(new CustomEvent('sf:validate'));
      if (nativeSubmit.disabled) {
        const missing = ['#sfk-city', '#sfk-letters', '#sfk-numbers'].map(selector => root.querySelector(selector)).find(input => input && !input.value.trim());
        const state = root.querySelector('#sfk-state-choice');
        const target = missing || (state && !state.hidden && !state.value ? state : root.querySelector('#sfk-error'));
        target?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        target?.focus({ preventScroll: true });
      } else if (form.reportValidity()) {
        form.requestSubmit(nativeSubmit);
      }
      update();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { rowVisible = entries[0].isIntersecting; update(); }).observe(row);
    }
    new MutationObserver(update).observe(nativeSubmit, { attributes: true, attributeFilter: ['disabled'] });
    const summary = root.querySelector('[data-price-summary]');
    if (summary) new MutationObserver(update).observe(summary, { childList: true, subtree: true });
    if ('ResizeObserver' in window) new ResizeObserver(measureBar).observe(bar);
    window.addEventListener('resize', measureBar, { passive: true });
    mobile.addEventListener('change', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();